export default __webpack_public_path__ + "static/logo7-4a69e3dba49de4aceb491dcb3aa1bfae.svg";